import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditProductNames extends Component {

    state = {
        productNames: this.props.productNames.join('\n')
    }

    onSave = () => {
        this.props.onSave({
            productNames: this.state.productNames.split('\n').join(',')
        })
    }

    render() {
        const { productNames = '' } = this.state

        return (
          <Modal
            narrow
            extraClassName="EditProductNames"
            onCancel={this.props.onClose}
            onSave={this.onSave}
            saveText="Save"
            mode="edit"
            title="Product names">
            <Form>
                <div>
                    <textarea 
                        placeholder="Product names"
                        value={productNames}
                        onChange={e => this.setState({ productNames: e.target.value })} />
                </div>
            </Form>
          </Modal>
        )
    }
}

export default EditProductNames



// WEBPACK FOOTER //
// ./src/components/LBUs/EditProductNames.js